// src/pages/ServerSettings.js
import React, { useState, useEffect } from "react";
import { getCurrentApiBase, setApiBase } from "./config";

export default function ServerSettings({ onSave }) {
  const [url, setUrl] = useState("");

  useEffect(() => {
    (async () => {
      const saved = await getCurrentApiBase();
      setUrl(saved);
    })();
  }, []);

  const handleSave = async () => {
    const clean = url.trim().replace(/\/+$/, "");

    if (!/^http:\/\/\d+\.\d+\.\d+\.\d+(:\d+)?$/.test(clean)) {
      alert("Invalid URL. Use: http://192.168.1.97:8888");
      return;
    }

    await setApiBase(clean);
    onSave?.();
    alert("Server updated!");
  };

  return (
    <div
      style={{
        padding: 30,
        maxWidth: 500,
        margin: "50px auto",
      
   
      }}
    >
      <h2 style={{ marginBottom: 20, color: "#333" }}>Server Settings</h2>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #ccc",
          borderRadius: 6,
          padding: "0 10px",
          marginBottom: 20,
          backgroundColor: "#f9f9f9",
        }}
      >
        <i class="ri-server-line"></i>
        <input
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="http://192.168.1.97:XXXX"
          style={{
            flex: 1,
            padding: 10,
            fontSize: 16,
            border: "none",
            outline: "none",
            backgroundColor: "transparent",
          }}
        />
      </div>

      <button
        onClick={handleSave}
        style={{
          padding: "10px 20px",
          display: "flex",
          alignItems: "center",
          gap: 8,
          background: "#007bff",
          color: "white",
          border: "none",
          borderRadius: 6,
          fontSize: 16,
          cursor: "pointer",
          transition: "background 0.3s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#0056b3")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "#007bff")}
      >
        <i class="ri-save-line"></i> Save
      </button>
    </div>
  );
}
